import React, { useCallback } from 'react';

import clsx from 'clsx';

import { useStyles } from './style';
import { Card, CardContent, Grid, Tooltip } from '@material-ui/core';
import xeroLogo from '../../../../assets/images/xero_logo.png';
import opLogo from '../../../../assets/images/op_logo.png';
import myobLogo from '../../../../assets/images/myob_logo.png';
import quickbooksLogo from '../../../../assets/images/quickbooks_logo.png';
import netsuiteLogo from '../../../../assets/images/netsuite_logo.png';
import sageLogo from '../../../../assets/images/sage_logo.png';
import waveLogo from '../../../../assets/images/wave_logo.png';
import zohoLogo from '../../../../assets/images/zoho_logo.png';
import microDynLogo from '../../../../assets/images/micro_dyn_logo.png';
import kashflowLogo from '../../../../assets/images/kashflow_logo.png';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../../store';
import { getMySubscriptionType } from '../../../../store/user';
import { useMeQuery } from '../../../../api/user';
import { ThemedButton } from '../../../../shared/components/themed-button';
import { UpgradeSubscriptionTooltip } from '../../../../shared/components/upgrade-subscription-tooltip';
import { SubscriptionPlanEnum } from '../../../../api/user/types';
import InfoIcon from '@material-ui/icons/Info';
import { WarningTooltip } from '../../../../shared/components/warning-tooltip';
import { useDisconnectMutation } from '../../../../api/xero';

export const ServiceItems: React.FC = () => {
  const classes = useStyles();
  const { push } = useHistory();
  const subscriptionType = useAppSelector(getMySubscriptionType);
  const { data: user } = useMeQuery();
  const [disconnect] = useDisconnectMutation();

  const onDisconnect = useCallback(() => {
    disconnect();
  }, []);

  const onContactUsClick = useCallback(() => {
    push('/account/help/contact');
  }, []);

  const onXeroClick = useCallback(() => {
    window.location.href = `${process.env.REACT_APP_API_URL}/xero/connect?user_id=${user?.id}`;
  }, []);

  const onMyobClick = useCallback(() => {
    window.location.href = `${process.env.REACT_APP_API_URL}/myob/connect?user_id=${user?.id}`;
  }, []);

  return (
    <Grid container spacing={3} className={classes.services}>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={opLogo} height={28} /></div>
            <p className={classes.logoText}>Orders Via SMTP/ Webhook Products & Prices Via API</p>
            <ThemedButton isSmall={true} onClick={onContactUsClick} className={classes.logoBtn} title='Get in touch' width={130} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={quickbooksLogo} height={44} /></div>
            <p className={classes.logoText2}>QuickBooks <br />(Intuit)</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={xeroLogo} height={44} /></div>
            <p className={classes.logoText2}>Xero</p>
            {
              subscriptionType === SubscriptionPlanEnum.FREE
                ? <UpgradeSubscriptionTooltip
                    text='Upgrade your subscription plan to unlock ‘Xero’ options' placement={'bottom-end'}>
                    <ThemedButton
                      buttonStyle='primaryBordered'
                      isSmall={true} className={classes.logoBtn} title='Connect' width={130}
                      disabled={true}
                    />
                  </UpgradeSubscriptionTooltip>
                : <ThemedButton
                    isSmall={true} width={130}
                    buttonStyle='primaryBordered'
                    className={clsx(classes.logoBtn, user?.has_xero_connection && classes.connected)}
                    title={user?.has_xero_connection ? 'Disconnect' : 'Connect'}
                    onClick={user?.has_xero_connection ? onDisconnect : onXeroClick}
                  />
              }
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={netsuiteLogo} height={44} /></div>
            <p className={classes.logoText2}>NetSuite Financials</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={sageLogo} height={44} /></div>
            <p className={classes.logoText2}>Sage Accounting<br />(Sage 50, Sage Intacct)</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={myobLogo} height={44} /></div>
            <p className={classes.logoText2}>MYOB</p>
            <div className={classes.myobBtns}>
            {
              subscriptionType === SubscriptionPlanEnum.FREE
                ? <UpgradeSubscriptionTooltip
                    text='Upgrade your subscription plan to unlock ‘MYOB’ options' placement={'bottom-end'}>
                    <ThemedButton
                      buttonStyle='primaryBordered'
                      isSmall={true} className={classes.logoBtn} title='Connect' width={130}
                      disabled={true}
                    />
                  </UpgradeSubscriptionTooltip>
                : <ThemedButton
                    isSmall={true} width={130}
                    buttonStyle='primaryBordered'
                    className={clsx(classes.logoBtn, user?.has_myob_connection && classes.connected)}
                    title={user?.has_myob_connection ? 'Connected' : 'Connect'}
                    onClick={onMyobClick}
                  />
            }
            <WarningTooltip
              className={classes.revokeTooltip}
              showButton={false}
              placement='top-end'
              text={<>
                Revoke access here <a target='_blank' className={classes.link} href='https://myaccount.myob.com/account/security#/integration'>https://myaccount.myob.com/account/security#/integration</a>
              </>}>
              <InfoIcon />
            </WarningTooltip>
            </div>
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={waveLogo} height={44} /></div>
            <p className={classes.logoText2}>Wave Accounting</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={zohoLogo} height={44} /></div>
            <p className={classes.logoText2}>Zoho Books</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={microDynLogo} height={44} /></div>
            <p className={classes.logoText2}>Microsoft Dynamics GP</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
      <Card className={classes.card}>
        <CardContent>
          <Grid item xs className={classes.serviceItem}>
            <div className={classes.logo}><img src={kashflowLogo} height={44} /></div>
            <p className={classes.logoText2}>KashFlow</p>
            <ThemedButton buttonStyle='primaryBordered' isSmall={true} onClick={onContactUsClick}
              className={classes.logoBtn} title='Request Integration' width={130} disabled={true} />
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};